import Button from '@/common/components/base/button/Button';
import LoadingButton from '@/common/components/base/button/loadingButton';
import MobileInput from '@/common/components/base/input/mobileInput/MobileInput';
import { MOBILE_NUMBER_RULE } from '@/common/components/base/input/mobileInput/mobileInput.rules';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import { ADDRESS_RULE } from '@/common/utils/rules/address.rules';
import { PHONE_NUMBER_RULE } from '@/common/utils/rules/phoneNumber.rules';
import { POSTAL_CODE_RULE } from '@/common/utils/rules/postalCode.rules';
import { requiredText } from '@/common/utils/rules/publicRules';
import { INITIAL_VISIT_LINKS } from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitLink';
import { DriverInfoTypeForm } from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/driver-owner/driverInfo/driverInfo.type';
import { getInitialVisitOwnerInformationQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialVisitOwnerInformation/getInitialVisitOwnerInformationQueryOptions';
import { useContactOwnerInitialVisitQuery } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchContactOwnerInitialVisit/patchContactDriverQueryOptions';
import { useQueryClient } from '@tanstack/react-query';
import { useFormContext, useWatch } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

const InitialBodyContactOwnerForm = () => {
  const methods = useFormContext<DriverInfoTypeForm>();
  const phoneNumber = useWatch({
    control: methods.control,
    name: 'contact_information.phone',
  });
  const client = useQueryClient();
  const { mutate, isPending } = useContactOwnerInitialVisitQuery();
  const { id } = useParams();
  const navigate = useNavigate();
  const onsubmit = (data: DriverInfoTypeForm) => {
    mutate(
      {
        fileId: String(id),
        data: {
          ...data.contact_information,
          postal_code: !!data?.contact_information?.postal_code
            ? data?.contact_information?.postal_code
            : null,
          city_code:
            data.contact_information?.city_code === ''
              ? null
              : data.contact_information?.city_code,
          phone:
            data.contact_information?.phone === ''
              ? null
              : data.contact_information?.phone,
          owner_type: String(
            methods.getValues().personal_information?.owner_type,
          ),
        },
      },
      {
        onSuccess: () => {
          navigate(-1);
        },
      },
    );
  };

  const previousStep = () => {
    // This invalidate query is just for refetching the query when i want to bak to the previous route
    // which gets this query at first and set the formData.

    client.invalidateQueries({
      queryKey: getInitialVisitOwnerInformationQueryOptions({ id: +id! })
        .queryKey,
    });
    methods.clearErrors();
    methods.trigger();
    navigate(INITIAL_VISIT_LINKS.OWNER_INITIAL_INFO(Number(id)), {
      replace: true,
    });
  };
  return (
    <Flex direction="column" gap={32}>
      <Box>
        <MobileInput
          name="contact_information.phone_number"
          label="تلفن همراه "
          rules={{ required: requiredText, ...MOBILE_NUMBER_RULE }}
        />
      </Box>
      <Box display="flex" flexDirection="row" gap="10px">
        <Box flexBasis={'80%'}>
          <TextInput
            name="contact_information.phone"
            label="تلفن ثابت"
            placeholder="XX-XX-XX-XX"
            key={'phone'}
            direction="ltr"
            rules={{ ...PHONE_NUMBER_RULE, required: requiredText }}
            max={8}
            noCharInput={true}
          />
        </Box>
        <Box flexBasis={'30%'}>
          <TextInput
            name="contact_information.city_code"
            key={'city_code'}
            direction="ltr"
            placeholder="کد شهر"
            rules={{
              minLength: { message: 'پیش شماره شهر 3 رقمی است', value: 3 },
              required: {
                message: requiredText,
                value: phoneNumber ? true : false,
              },
            }}
            max={3}
            noCharInput={true}
          />
        </Box>
      </Box>
      <Box>
        <TextInput
          label="کدپستی"
          name="contact_information.postal_code"
          placeholder="کدپستی را وارد کنید"
          rules={{ ...POSTAL_CODE_RULE }}
          defaultValue=""
          optionalLabel
          noCharInput
          max={10}
        />
      </Box>
      <Box>
        <TextInput
          label="آدرس"
          name="contact_information.address"
          placeholder="آدرس را وارد کنید"
          rules={{ required: requiredText, ...ADDRESS_RULE }}
          defaultValue=""
        />
      </Box>
      <Flex w="100%" gap={16} mb="1rem">
        <Button fullWidth variant="outlined" onClick={previousStep}>
          مرحله قبل
        </Button>{' '}
        <LoadingButton
          onClick={methods.handleSubmit(onsubmit)}
          loading={isPending}
          fullWidth
          disabled={!methods?.formState?.isValid}
        >
          ثبت
        </LoadingButton>
      </Flex>
    </Flex>
  );
};
export default InitialBodyContactOwnerForm;
